import type { CheckoutRawEvent } from "@b2bportal/core-checkout";
import type { EventTransformerHooks } from "@b2bportal/core-tracking";
import type { CarsCheckoutEvent } from "./events";

export const CARS_CHECKOUT_TRANSFORMER_HOOKS: EventTransformerHooks<
  CheckoutRawEvent,
  CarsCheckoutEvent
> = {
  // Placeholder for future transformers
};
